import { i18nTranslate } from 'src/utils'
import { countryData } from '../../SignUpForms/countryCodeData'
import { cartContainer, customerContainer } from 'src/models'
import { APPConfig, convertToBoolean } from 'config/appConfig'
import './styles.scss'

let inputCode = countryData()?.find(element => element.value === 'IN')?.value
let phoneCountryCodeOptions = []
countryData()?.forEach(val =>
  phoneCountryCodeOptions.push({
    ...val,
    label: val.displayValue,
  })
)

const METHOD_IDS = {
  SMS: 'prefersmsOption',
  Email: 'preferEmailOption',
  WhatsApp: 'preferWhatsAppOption',
}

const preferContactMethodHandler = e => {
  const selected = e?.target?.name
  if (!selected) return

  cartContainer.setSelectedPreferContactMethod(selected)

  Object.entries(METHOD_IDS).forEach(([method, id]) => {
    const el = document.getElementById(id)
    if (el) el.checked = method === selected
  })
}

const importedDeviceFormInput = (validationErrors = {}, parsedPhoneNumber) => {
  const { profileResponse } = customerContainer || {}
  const enableWhatsappMessages =
    convertToBoolean(APPConfig?.getAppConfig()?.enableWhatsappMessages) || false

  const contactMethodOptions = [
    {
      name: 'SMS',
      id: 'prefersmsOption',
      type: 'radio',
      value: true,
      supportedUserType: ['registeredUser'],
      className: 'col-6 col-md-3 col-lg-3',
      dataTestId: 'qa-contacted-via-sms',
      defaultChecked: 'true',
    },
  ]

  if (enableWhatsappMessages) {
    contactMethodOptions.push({
      name: 'WhatsApp',
      id: 'preferWhatsAppOption',
      type: 'radio',
      value: false,
      supportedUserType: ['registeredUser'],
      className: 'col-6 col-md-3 col-lg-3 mr-5',
      dataTestId: 'qa-contacted-via-whatsapp',
    })
  }

  contactMethodOptions.push({
    name: 'Email',
    id: 'preferEmailOption',
    type: 'radio',
    supportedUserType: ['registeredUser'],
    className: 'col-6 col-md-3 col-lg-3',
    dataTestId: 'qa-contacted-via-email',
  })

  return [
    [
      {
        name: 'firstName',
        ariaLabel: 'firstName',
        defaultValue: profileResponse?.firstName || '',
        placeholderKey: 'firstNamePlaceHolder',
        dataTestId: 'qa-first-name',
        customClassName: 'input-border-radius',
        columnType: {
          lg: '6',
        },
        maxLength: 50,
      },
      {
        name: 'lastName',
        ariaLabel: 'lastName',
        defaultValue: profileResponse?.lastName || '',
        placeholderKey: 'lastNamePlaceHolder',
        dataTestId: 'qa-last-name',
        customClassName: 'input-border-radius',
        columnType: {
          lg: '6',
        },
        maxLength: 50,
      },
    ],
    {
      name: i18nTranslate(
        'notifyDirectSellerPopup.errorText',
        'Please provide at least one contact method*'
      ),
      type: 'div',
      customClassName: 'my-1 h1 contactInfo font-weight-bolder mt-3',
      columnType: {
        lg: '12',
      },
    },
    [
      {
        name: 'Phone Number',
        type: 'select',
        options: [...phoneCountryCodeOptions],
        columnType: {
          lg: '4',
        },
        dataTestId: 'qa-dropdown-countrycode',
        defaultValue: inputCode,
        customClassName: 'input-border-radius',
        ariaLabel: 'phoneCountryCode',
        phoneNumberDropDown: true,
      },
      {
        name: 'phone',
        ariaLabel: 'phone',
        defaultValue: parsedPhoneNumber || '',
        pattern: '[0-9]*',
        columnType: {
          lg: '8',
        },
        dataTestId: 'qa-telephone',
        placeholderKey: 'phoneNoPlaceHolder',
        maxLength: 10,
        required: false,
        isToHideLabel: true,
        customClassName: 'input-border-radius imported-phone-input',
        type: 'mask',
      },
    ],
    ...(validationErrors?.phone
      ? [
          {
            type: 'div',
            customClassName: 'text-danger mt-1 mb-2',
            columnType: { lg: '12' },
            isToHideLabel: true,
            style: { fontSize: '14px' },
            children: validationErrors.phone,
          },
        ]
      : []),
    {
      name: 'userEmailAddress',
      columnType: {
        lg: '12',
      },
      customClassName: 'input-border-radius mb-1 mt-2',
      dataTestId: 'qa-createaccount-email',
      ariaLabel: 'email',
      defaultValue: profileResponse?.email || '',
      required: false,
      placeholderKey: 'userEmailAddress',
    },
    ...(validationErrors?.userEmailAddress
      ? [
          {
            type: 'div',
            customClassName: 'text-danger mt-1 mb-2',
            columnType: { lg: '12' },
            isToHideLabel: true,
            style: { fontSize: '14px' },
            children: validationErrors.userEmailAddress,
          },
        ]
      : []),
    {
      name: 'preferContactMethod',
      type: 'radio',
      isFieldSet: true,
      isToHideLabel: true,
      dataTestId: 'qa-contacted-via',
      componentToRender: ['checkout'],
      isToHideField: false,
      onValueChange: preferContactMethodHandler,
      optionSet: contactMethodOptions,
      customClassName: 'prefer-contact-method',
    },
  ]
}

export { importedDeviceFormInput }
